export const STANDARD_ROW_HEIGHT = { hpt: 15 };
export const HEADINGS_ROW_HEIGHT = { hpt: 25 };
export const BOLD_ROW_HEIGHT = { hpt: 20 };

export const STANDARD_FONT_SIZE = 10;
export const SECTION_HEADER_FONT_SIZE = 10;

export const THIN_BORDER = { style: 'thin', color: '#000000' };
export const DOUBLE_BORDER = { style: 'double', color: '#000000' };

export const APP_NAME = 'Tax Lifecycle Solutions (TLS)';
export const FILE_EXTENSION = 'xlsx';

export const CUSTOM_NUMBER_CELL_FORMAT = '#,##0.00;(#,##0.00)';
export const CUSTOM_NUMBER_CELL_FORMAT_WO_ZERO = '#,##0.00;(#,##0.00);;@';
export const CUSTOM_NUMBER_CELL_FORMAT_WO_DECIMALS = '#,##0;(#,##0)';
export const CUSTOM_NUMBER_CELL_FORMAT_WO_ZERO_WO_DECIMALS = '#,##0;(#,##0);;@';
export const CUSTOM_PERCENT_4_CELL_FORMAT = '0.0000%';
export const CUSTOM_PERCENT_4_CELL_FORMAT_WO_ZERO = '0.0000%;-0.0000%;;@';
export const CUSTOM_PERCENT_6_CELL_FORMAT = '0.000000%';
export const NUMBER_8_CELL_FORMAT = '0.00000000';

export const MAX_NESTING_LEVEL = 5;

export const NumeralTypes = {
  NUMBER: 'NUMBER',
  DECIMAL: 'DECIMAL',
  PERCENTAGE: 'PERCENTAGE',
  PERCENT_4: 'PERCENT_4',
  PERCENT_2: 'PERCENT_2',
};

export enum CellExportFormats {
  CUSTOM_TEXT = 'CUSTOM_TEXT',
  NUMBER = 'NUMBER',
  DECIMAL = 'DECIMAL',
  PERCENT_6 = 'PERCENT_6',
  PERCENT_4 = 'PERCENT_4',
  PERCENT_2 = 'PERCENT_2',
  OWNERSHIP = 'OWNERSHIP',
}

/**
 * @name SheetExportTypes
 * @enum {string}
 */
export enum SheetExportTypes {
  GRID = 'GRID',
  REPORT = 'REPORT',
  CUSTOM = 'CUSTOM',
  ETR_REPORT = 'ETR_REPORT',
  TEMPLATE_INSTRUCTIONS = 'TEMPLATE_INSTRUCTIONS',
  SCENARIO_REPORT = 'SCENARIO_REPORT',
}

export const Width = {
  multiplier: 0.15,
  firstColumnMultiplier: 0.5,
};

export const TYPES = {
  STRING: 'STRING',
};

export const REPORT_ROW_TYPES = {
  CHILD_DATA_BOLD: 'CHILD_DATA_BOLD',
};

export const ETRConstants = {
  SortOrders: {
    INCOME_BEFORE_TAX: 101,
    TAX_RATE: 102,
    INCOME_AT_SELECTED_RATE: 103,
  },
  Sections: {
    PROVISION_FOR_INCOME_TAXES: 'M',
    EFFECTIVE_TAX_RATE: 'N',
  },
};

export const ScenariosConstants = {
  NoDetailValue: 'N/A',
  BASE_PREFIX: 'BASE_',
  COMPARE_PREFIX: 'COMPARE_',
  VARIANCE_PREFIX: 'VARIANCE_',
};


export const MAX_OUTLINE_LEVEL = 7;
